import { Divider } from "../../components/Divider";
import { TROK0 } from "./TROK0";

export function TROKWTD() {
    return <div className='trok-main'>
        <h2>What to Do</h2>
        <Divider />
        <h2>Sights</h2>
        <h4>Sponsored by Flushmore Industries</h4>
        <Divider />
        <p>Go to Mt Flushmore and learn about history of industry</p>
        <Divider />
        <h2>Dining</h2>
        <Divider />
        <p>Diner</p>
        <Divider />
        <h2>Third Thing</h2>
        <Divider />
    </div>
}